import { IOfferDescriptionVisualParameter } from "./IOfferDescriptionVisualParameter";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 16.04.13
 * Time: 14:31
 */

import { BasicPrivateOfferVO } from "../../BasicPrivateOfferVO";
import { Constants_Offer } from "../../Constants_Offer";
import { PrivateOfferStateEnum } from "../../PrivateOfferStateEnum";

/**
 * Visual parameter to set an order for rewards
 */
export class OfferDescriptionVisualRewardSlotOrder implements IOfferDescriptionVisualParameter {
    private _sortOrder: any[];

    constructor(sortOrder: any[]) {
        this._sortOrder = sortOrder;
    }

    public get name(): string {
        return Constants_Offer.OFFER_VISUAL_REWARD_SLOT_ORDER;
    }

    public parseFromObjectParam(params: any): void {
        this._sortOrder = params.SO;
    }

    public execute(offerVO: BasicPrivateOfferVO): boolean {
        // nothing to do, will never called with toExecuteInState = false
        return true;
    }

    public toExecuteInState(state: PrivateOfferStateEnum): boolean {
        return false;	// this element has no execution state, it is just for getting from dialog site
    }

    public get sortOrder(): any[] {
        return this._sortOrder;
    }

    public dispose(): void {
    }

    public getCommandName(): string {
        return "";
    }
}

